import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from '../store/actions';
import { LinearProgress } from '@mui/material';
import { withStyles } from '@mui/styles';
import Login from '../containers/Login/Login';
import TenantSelector from '../containers/Login/TenantSelector';

const BorderLinearProgress = withStyles((theme) => ({
    root: {
      height: 5,
    },
    bar: {
      backgroundColor: 'green',
    },
  }))(LinearProgress);

const withSession = Component => props => {

    const dispatch = useDispatch();
    const token = localStorage.getItem('token');
    const tenant = localStorage.getItem('selectedTenant');
    const name = useSelector(state => state.auth.name)
    const selectedAccess = useSelector(state => state.auth.selectedAccess)
    const access = useSelector(state => state.auth.access)


    if(token && name && selectedAccess && tenant && access) {
        console.log('caiu no 1');
        return <Component {...props}/>
    } else if (token && name && access && !tenant){
        console.log('caiu no 2');
        return <TenantSelector />
    } else if (token) {
        console.log('caiu no 3');
        dispatch(actions.getMe()).then(res => {
            if(res === 'error') {
                localStorage.removeItem('token');
                localStorage.removeItem('selectedTenant');
                props.history.push('/login');
            }
        }).catch(e => {
          localStorage.removeItem('token');
          localStorage.removeItem('selectedTenant');
          props.history.push('/login');
        })

        return (
            <div>
                <BorderLinearProgress />
            </div>
        )
    } else {
        console.log('caiu no 3');
        return <Login />
    }

}

export default withSession;
